import { ICountryItem } from "../../config/interfaces";

export function check_valid_country_format(field: ICountryItem | null, country: ICountryItem): ICountryItem | number | undefined {
    if (field === null) return;

    return typeof field === 'number' ? country : field.id;
}